export { detectLinearLink } from './linear';
export { detectGitHubLink } from './github';
export { detectJIRALink } from './jira';
export { detectNotionLink } from './notion';
export { detectSlackLink } from './slack';
export { detectZoomLink } from './zoom';
export { detectAsanaLink } from './asana';

import type { DetectedLink } from '../../integrations';
import { detectLinearLink } from './linear';
import { detectGitHubLink } from './github';
import { detectJIRALink } from './jira';
import { detectNotionLink } from './notion';
import { detectSlackLink } from './slack';
import { detectZoomLink } from './zoom';
import { detectAsanaLink } from './asana';

/** Back-compat aliases used by external-ticket code paths. */
export {
  detectAsanaLink as detectAsanaTicketLink,
  detectLinearLink as detectLinearTicketLink,
  detectGitHubLink as detectGitHubTicketLink,
  detectJIRALink as detectJiraTicketLink,
  detectNotionLink as detectNotionTicketLink,
};

export function detectIntegrationLink(url: string): DetectedLink | null {
  return (
    detectLinearLink(url) ||
    detectGitHubLink(url) ||
    detectJIRALink(url) ||
    detectNotionLink(url) ||
    detectSlackLink(url) ||
    detectZoomLink(url) ||
    detectAsanaLink(url)
  );
}

export function extractIntegrationLinks(text: string): DetectedLink[] {
  const urlRegex = /https?:\/\/[^\s<>"{}|\\^`[\]]+/gi;
  const urls = text.match(urlRegex) || [];
  const links: DetectedLink[] = [];
  for (const url of urls) {
    const detected = detectIntegrationLink(url);
    if (detected) links.push(detected);
  }
  return links;
}

/** Links the integration-content MCP tool can fetch (excludes Slack channel-only URLs). */
export function extractFetchableIntegrationLinks(text: string): DetectedLink[] {
  return extractIntegrationLinks(text).filter((link) => !(link.integrationType === 'slack' && link.isChannel));
}
